import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Contractor } from '../_models/contractor';
import { RestService } from '../_services/rest.service';
import { DatePipe } from '@angular/common';
import { Contact } from '../_models/contact';
import { Insurance } from '../_models/insurance';
import { Licencing } from '../_models/licencing';
import { ContractorTrade } from '../_models/contractor-trade';
import { FunctionsService } from '../_services/functions.service';
import { State } from '../_models/state';
import { Observable } from 'rxjs';
import { GeoRegion } from '../_models/georegion';
import { EntityType } from '../_models/entitytype';
import { Status } from '../_models/status';
import { AlertService } from '../_services';
import { Insurer } from '../_models/insurer';
import { LicenceClassification } from '../_models/licence-classification';
import { MatTableDataSource } from '@angular/material/table';
import { Note } from '@app/_models/note';
import { MatSort, MatSortable } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { InputRefNoDialog } from '@app/home';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { EmailRecord } from '@app/_models/email-record';
import { MatTabGroup } from '@angular/material/tabs';
import { MsalService } from '@azure/msal-angular';
import { Email } from '@app/_models/email';
import { JobStatus } from '@app/_models/job-status';
import { NoteType } from '@app/_models/noteTypes';
import { DocumentUploadPermission, Mk3Instructions, NIBInstructions, NIBQuoteRequest, PdfType, RRInstructions, RRQuoteRequest } from '@app/_helpers/constants';
import { DocumentDetailsComponent } from './document-details/document-details.component';
import { DocumentRecords } from '@app/_models/document-records';
import { GlobalValues } from '@app/_services/global-values';
import { groups } from '@app/auth-config';
import { TncAgreement } from '@app/_models/tncAgreement';
import { v4 as uuidv4 } from 'uuid';
import { HttpResponse } from '@angular/common/http';
import * as moment from 'moment';
import { DocumentDetail } from '@app/_models/document-detail';
import { ADUser } from '@app/_models';
import { EmailRecordExPdfData } from '@app/_models/email-record-ex-pdfdata';
import { UtilsService } from '@app/_services/utils.service';

@Component({
  selector: 'app-contractor-details',
  templateUrl: './contractor-details.component.html',
  styleUrls: ['./contractor-details.component.scss'],
})
export class ContractorDetailsComponent implements OnInit, AfterViewInit {
  selectedTabIndex: number = 0;
  @ViewChild('gridWrapper', { read: ElementRef }) gridWrapper!: ElementRef;
  matGridListHeight = 0;
  displayedNotesColumns: string[] = [
    'noteTypeId',
    'refNo',
    'comments',
    'addedBy',
    'timeStamp',
  ];

  displayedEmailRecordsColumns: string[] = [
    'id',
    'refNo',
    'instructionTypeId',
    'attachmentName',
    'category',
    'clientFriendlyName',
    'dateSent',
    'sentBy',
    'statusId',
    'details',
    'viewDocument',
    'retract'
  ];
  
  displayedQualityReviewsColumns: string[] = [
    //'id',
    'jobId', 
    //'refNo',   
    'comments',
    'qoWscore',
    'jobTimeScore',
    'hscandAqscore',
    'addedBy',
    'addedOn'
  ];

  dataSourceDocumentDetailColumn: string[] = [
    'documentId', 
    'contractorId',
    'documentType',
    'expireDate',
    'addedBy',
    'addedOn',
    'comment',
    'action'
  ];

  isLoading = true;
  existingInstructionQuoteRequest:EmailRecordExPdfData[]=[];
  searchValue = '';//localStorage.getItem('searchTextContractorInstructions') ? localStorage.getItem('searchTextContractorInstructions') : '';
  searchValueInstructionClose = '';
  searchValueInstructionOpen = '';
  searchValueInstructionAll = '';
  isCompliant = true;
  dataSourceNotes!: MatTableDataSource<Note>;
  dataSourceEmailRecords!: MatTableDataSource<any>;
  dataSourceQualityReviews!: MatTableDataSource<any>;
  dataSourceForEmailRecords!: MatTableDataSource<any>;
  dataSourceDocumentDetail!: MatTableDataSource<DocumentRecords>;
  contractor = <Contractor>{};
  contact = <Contact>{};
  insurance = <Insurance>{};
  licence = <Licencing>{};
  tradesCheckedList: number[] = [];
  state!: Observable<State>;
  geoRegion!: Observable<GeoRegion>;
  entityType!: Observable<EntityType>;
  statuses!: Observable<Status>;
  plInsurer!: Observable<Insurer>;
  wcaInsurer!: Observable<Insurer>;
  licenceClassification!: Observable<LicenceClassification>;
  contractorID = 0;
  breakpoint!: number;
  jobStatusesArray: Array<JobStatus> = [];
  noteTypes!: Observable<any>;
  noteTypesArray: Array<NoteType> = [];
  instructionType:string[]=[];
  hasPermissionToUploadDocument= false;
  userDetails!: ADUser;
  pdfType = PdfType;

  licenceRequired = [
    { id: 1, text: 'Yes' },
    { id: 0, text: 'No' },
  ];
  swmsRequired = [
    { id: 1, text: 'Yes' },
    { id: 0, text: 'No' },
  ];
  navLinks: any[];
  activeLinkIndex = -1;
  @ViewChild(MatSort, { static: false })
  matSortCommon: MatSort = new MatSort();
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;

  inputDialogRef: any;

  onTabClick(event: any) {
    this.selectedTabIndex = event.index;
    this.alertService.clear();
  //this.dataSourceEmailRecords.data.splice(0, this.dataSourceEmailRecords.data.length);
  if(this.selectedTabIndex == 2)
      this.getNotes();
  else if(this.selectedTabIndex == 3)
      this.getQuotesByContractorId();
  else if(this.selectedTabIndex == 4)
      this.getInstructionsOpenByContractorId();
  else if(this.selectedTabIndex == 5)
      this.getInstructionsClosedByContractorId();
  else if(this.selectedTabIndex == 6)
    this.getInstructionsAllByContractorId();
  else if(this.selectedTabIndex == 7)
      this.getQualityReviewsByContractorId();
  else if(this.selectedTabIndex == 8)
      this.getDocumentDetailByContractorId();
  }

  constructor(
    private globalValues:GlobalValues,
    public restService: RestService,
    private route: ActivatedRoute,
    private router: Router,
    public functionsService: FunctionsService,
    public dialog: MatDialog,
    private host: ElementRef,
    private msalService: MsalService,
    private alertService: AlertService,
    public appComponent: AppComponent,
    private datePipe: DatePipe,
    private utils:UtilsService,
    public documentUploadDialogRef: MatDialogRef<DocumentDetailsComponent>
    ) {
      this.navLinks = [
        {
          label: 'Contractor Details',
          link: './contractor-details',
          index: 0,
        },
        {
          label: 'Insurance & Licence Details',
          link: './insurance-licence-details',
          index: 1,
        },
        {
          label: 'Notes',
          link: './notes',
          index: 2,
        },
        {
          label: 'Instructions/ Quotes',
          link: './instructions-quotes',
          index: 3,
        },
      ];
    }

    ngAfterViewInit() {
     setTimeout(() => {
        if (this.gridWrapper) {
          const el = this.gridWrapper.nativeElement as HTMLElement;
          this.matGridListHeight = el.scrollHeight + 30;
        }
      });
      //setTimeout(() => this.adjustTabHeight(), 0);
    //   setTimeout(() => {
    //   const contentEl = this.tabContent.nativeElement as HTMLElement;
    //   const scrollHeight = contentEl.scrollHeight+40;

    //   // Find parent .mat-tab-body-content
    //   const tabBody = contentEl.closest('.mat-tab-body-content') as HTMLElement;
    //   if (tabBody) {
    //     tabBody.style.height = scrollHeight + 'px';
    //     tabBody.style.overflow = 'visible'; // ensures inner content not clipped
    //   }
    // }, 0);
  }

    updateGridHeight() {
      if (this.gridWrapper) {
        const el = this.gridWrapper.nativeElement as HTMLElement;
        this.matGridListHeight = el.scrollHeight + 70; // add buffer
      }
    }
      // Find the active mat-tab-body-content
      // const tabContent = this.host.nativeElement.querySelector('.mat-tab-body-content');
      // if (tabContent) {
      //   tabContent.style.height = 'auto'; // or 'auto' or 'calc(100% + 70px)'
      //   tabContent.style.minHeight = '700px';
      //   tabContent.style.overflow = 'visible';
      // }
  
    ngOnInit() {
    this.instructionType[1] = NIBInstructions;
    this.instructionType[2] = NIBQuoteRequest;
    this.instructionType[3] = RRInstructions;
    this.instructionType[4] = RRQuoteRequest;
    this.instructionType[5] = Mk3Instructions;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';

    this.restService.getJobStatuses().subscribe((jobStatuses: JobStatus[]) => {
      this.jobStatusesArray = jobStatuses;
    });
    this.restService.getNoteTypes().subscribe((noteTypes: NoteType[]) => {
      this.noteTypesArray = noteTypes;
    });

    this.route.queryParams.subscribe((params) => {
      if (params.tabId) {
        this.changeTab(Number(params.tabId));
      }
    });

    this.breakpoint = window.innerWidth <= 480 ? 1 : 4;
    //Get contractor details
    this.restService
      .getContractorDetails(this.route.snapshot.params.contractorId)
      .subscribe((data: Contractor) => {
        this.contractor = { ...data };
        this.contractorID = this.contractor.contractorId;
        if (Number.isInteger(data.stateId))
          this.state = this.restService.getState(data.stateId);
        if (Number.isInteger(data.geoRegionId))
          this.geoRegion = this.restService.getGeoRegion(data.geoRegionId);
        if (Number.isInteger(data.entityTypeId))
          this.entityType = this.restService.getEntityType(data.entityTypeId);
        if (Number.isInteger(data.statusId))
          this.statuses = this.restService.getStatus(data.statusId);
        this.isLoading = false;
        if (this.contractor.complianceStatus < 5) this.isCompliant = false;
      });

    //Get contractor details
    this.restService
      .getContactDetails(this.route.snapshot.params.contractorId)
      .subscribe((data: Contact) => {
        this.contact = { ...data };
      });

    //Get contractor details
    this.restService
      .getInsuranceDetails(this.route.snapshot.params.contractorId)
      .subscribe((data: Insurance) => {
        this.insurance = { ...data };
        if (Number.isInteger(data.plinsurerId))
          this.plInsurer = this.restService.getInsurer(data.plinsurerId);
        if (Number.isInteger(data.wcsainsurerId))
          this.wcaInsurer = this.restService.getInsurer(data.wcsainsurerId);
      });

    //Get contractor details
    this.restService
      .getLicencingDetails(this.route.snapshot.params.contractorId)
      .subscribe(
        (data: Licencing) => {
          this.licence = { ...data };
          if (Number.isInteger(data.licenceClassificationId))
            this.licenceClassification =
              this.restService.getLicenceClassification(
                data.licenceClassificationId
              );
        },
        (error) => {
          console.error;
        }
      );

    this.restService
      .getSelectedTrades(this.route.snapshot.params.contractorId)
      .subscribe(
        (data: ContractorTrade[]) => {
          this.tradesCheckedList = [];
          this.tradesCheckedList = data.map((t) => t.tradeId);
          this.isLoading = false;
        },
        () => {
          console.error;
        }
      );
    //this.getNotes();
    //this.getEmailRecords();
    this.getUserDetails();
  }

  changeTab(tabIndex: number) {
    this.selectedTabIndex = tabIndex;
    this.route.queryParams.forEach((key) => {
      delete key.params;
    });
  }

  //Get Notes
  getNotes() {
    this.restService
      .getNotes(Number(this.route.snapshot.params.contractorId))
      .subscribe(
        (notes) => {
          this.dataSourceNotes = new MatTableDataSource(notes);
          this.dataSourceNotes.sort = this.matSortCommon;
        },
        (error) => {
          this.isLoading = false;
          this.alertService.error(error);
        }
      );
  }

  openNoteDialog() {
    this.router.navigate([
      '../../contractor-details/new-note/',
      this.contractor.contractorId,
      this.contractor.tradingName,
    ]);
  }

  getQuotesByContractorId() {
    this.isLoading = true;
    return this.restService
      .getQuotesByContractorId(this.route.snapshot.params.contractorId)
      .subscribe({
        next: (emailRecords) => {
          this.dataSourceEmailRecords = new MatTableDataSource(emailRecords);
          this.dataSourceForEmailRecords =this.dataSourceEmailRecords;
          this.dataSourceEmailRecords.filter = this.searchValue ? this.searchValue : '';//JSON.parse(localStorage.getItem('searchTextContractorInstructions')!);
          //this.dataSourceEmailRecords.filter = this.searchValue;
          this.dataSourceEmailRecords.sort = this.matSortCommon;
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.alertService.error(error);
        },
      });
  }
  
  getInstructionsAllByContractorId() {
    this.isLoading = true;
    return this.restService
      .getInstructionsAllByContractorId(this.route.snapshot.params.contractorId)
      .subscribe({
        next: (emailRecords) => {
          this.dataSourceEmailRecords = new MatTableDataSource(emailRecords);
          this.dataSourceEmailRecords.filteredData.forEach(item => {
            item.jobStatus = this.getJobStatus(item.statusId);
            item.instructionType = this.instructionType[item.instructionTypeId];
          });
          this.dataSourceForEmailRecords =this.dataSourceEmailRecords;
          this.filterInstructions(this.searchValueInstructionAll);
          this.dataSourceEmailRecords.sort = this.matSortCommon;
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.alertService.error(error);
        },
      });
  }

  getInstructionsOpenByContractorId() {
    this.isLoading = true;
    return this.restService
      .getInstructionsOpenByContractorId(this.route.snapshot.params.contractorId)
      .subscribe({
        next: (emailRecords) => {
          this.dataSourceEmailRecords = new MatTableDataSource(emailRecords);
          this.dataSourceEmailRecords.filteredData.forEach(item => {
            item.jobStatus = this.getJobStatus(item.statusId);
            item.instructionType = this.instructionType[item.instructionTypeId];
          });
          this.dataSourceForEmailRecords =this.dataSourceEmailRecords;
          //this.dataSourceEmailRecords.filter = this.searchValueInstructionOpen ? this.searchValueInstructionOpen : '';//JSON.parse(localStorage.getItem('searchTextContractorInstructions')!);
          //this.dataSourceEmailRecords.filter = this.searchValue;
          this.filterInstructions(this.searchValueInstructionOpen);
          this.dataSourceEmailRecords.sort = this.matSortCommon;
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.alertService.error(error);
        },
      });
  }
  
  getInstructionsClosedByContractorId() {
    this.isLoading = true;
    return this.restService
      .getInstructionsClosedByContractorId(this.route.snapshot.params.contractorId)
      .subscribe({
        next: (emailRecords) => {
          this.dataSourceEmailRecords = new MatTableDataSource(emailRecords);
          this.dataSourceEmailRecords.filteredData.forEach(item => {
            item.jobStatus = this.getJobStatus(item.statusId);
            item.instructionType = this.instructionType[item.instructionTypeId];
          });
          this.dataSourceForEmailRecords =this.dataSourceEmailRecords;
          //this.dataSourceEmailRecords.filter = this.searchValueInstructionClose ? this.searchValueInstructionClose : '';//JSON.parse(localStorage.getItem('searchTextContractorInstructions')!);
          //this.dataSourceEmailRecords.filter = this.searchValue;
          this.filterInstructions(this.searchValueInstructionClose);
          this.dataSourceEmailRecords.sort = this.matSortCommon;
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.alertService.error(error);
        },
      });
  }
  
  getQualityReviewsByContractorId() {
    this.isLoading = true;
    return this.restService
      .getQualityRatingsByContractorId(this.route.snapshot.params.contractorId)
      .subscribe({
        next: (qualityReviews) => {
          this.dataSourceQualityReviews = new MatTableDataSource(qualityReviews);
          //this.dataSourceQualityReviews.filter = this.searchValue ? this.searchValue : '';
          this.dataSourceQualityReviews.sort = this.matSortCommon;
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.alertService.error(error);
        },
      });
  }
  
  getEmailRecords() {
    this.isLoading = true;
    return this.restService
      .getEmailRecordsByContractorId(this.route.snapshot.params.contractorId)
      .subscribe({
        next: (emailRecords) => {
          this.dataSourceEmailRecords = new MatTableDataSource(emailRecords);
          this.dataSourceEmailRecords.filter = this.searchValue ? this.searchValue : '';//JSON.parse(localStorage.getItem('searchTextContractorInstructions')!);
          //this.dataSourceEmailRecords.filter = this.searchValue;
          this.dataSourceEmailRecords.sort = this.matSortCommon;
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.alertService.error(error);
        },
      });
  }


  openInstructionPDF(emailRecordId: number) {
    this.restService.getEmailRecord(emailRecordId).subscribe(
      (data: EmailRecord) => {
        this.functionsService.openPdf(data.pdfData);
      },
      (error) => {
        this.alertService.error(error);
      }
    );
  }

  downloadPdf(base64String: any, fileName: string) {
    const source = base64String;
    const link = document.createElement('a');
    link.href = source;
    link.setAttribute('target', '_blank');
    link.download = fileName;
    link.click();
  }

  newWorkInstructions() {
    if (this.contractorID && this.contractor.contractorId) {
      this.restService.getEmailRecordsByContractorId(this.contractorID).subscribe({
        next: (x:EmailRecordExPdfData[])=>{
          this.existingInstructionQuoteRequest = x;
          const numberOfOpenTrades = x.filter(x=>(x.instructionTypeId===1 || x.instructionTypeId===3 || x.instructionTypeId===5) && x.statusId !== 2 && x.statusId !==10).length;
          if (numberOfOpenTrades>=4){
            Swal.fire({
              title: 'This Contractor has '+ numberOfOpenTrades + ' existing open Instructions, Are you sure you want to send a new one to this Contractor?',
              icon: 'question',
              showDenyButton: true,
              confirmButtonText: `Yes`,
              denyButtonText: `No`,
              confirmButtonColor: '#007bff',
              denyButtonColor: '#dc3545',
              focusDeny: true,
              width: 450,
              padding: '1em',
              heightAuto: false,
            }).then(async (result) => {
              if (result.isConfirmed) {
                if (!this.isCompliant) {
                  this.alertService.clear();
                  Swal.fire({
                    title:
                      'Contractor Is identified as Non-Compliant with Mk3/NIB.<br/>Please do not send instruction to this contractor unless you have clearance from the state manager.<br/><br/>Are you sure you want to go ahead with sending Instructions/ Quote Request to this contractor?',
                    icon: 'warning',
                    showDenyButton: true,
                    confirmButtonText: `Yes`,
                    denyButtonText: `No`,
                    confirmButtonColor: '#007bff',
                    denyButtonColor: '#dc3545',
                    focusDeny: true,
                    width: 450,
                    padding: '1em',
                    heightAuto: false,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.openInputRefNoDialog();
                    } else if (result.isDenied) {
                      this.isLoading = false;
                    }
                  });
                } else {
                  this.openInputRefNoDialog();
                }
              } else if (result.isDenied) {
                this.isLoading = false;
                return;
              }
            });
          }
          else{
            this.openInputRefNoDialog();
          }
        },
        error: (err) => {
          console.error('Error occurred:getEmailRecordsByContractorId', err);
        },
      });
    }
    else {
      Swal.fire(
        'Cannot send Work Instruction / Quote Request!\r\nContractor did not load completely!Please check your internet and wait the contractor detail loaded compeletely before to send. Please refresh and try again!',
        '',
        'error'
      ).then(() => {
        window.location.reload();
      });
    }
  }

  openInputRefNoDialog() {
    if (
      this.licence.licenceConditions != '' &&
      this.licence.licenceConditions != null
    ) {
      Swal.fire({
        title:
          'This Contractor has the special licence conditions as below.<br/><br/>Are you sure you want to proceed and send the instructions/quote to them?<br/><br/><div class="red-text-highlighted">' +
          this.licence.licenceConditions +
          '</div>',
        icon: 'question',
        showDenyButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `No`,
        confirmButtonColor: '#007bff',
        denyButtonColor: '#dc3545',
        focusDeny: true,
        width: 450,
        padding: '1em',
        heightAuto: false,
      }).then((result) => {
        if (!result.isConfirmed) {
          this.isLoading = false;
          return;
        } else {
          this.inputDialogRef = this.dialog.open(InputRefNoDialog, {
            minWidth: '400px',
            maxWidth: '1000px',
            data: {
              contractor: this.contractor,
              userName: this.appComponent.getUserName(),
              userEmail: this.appComponent.getUserEmail(),
            },
          });
        }
      });
    } else {
      this.inputDialogRef = this.dialog.open(InputRefNoDialog, {
        minWidth: '400px',
        maxWidth: '1000px',
        data: {
          contractor: this.contractor,
          userName: this.appComponent.getUserName(),
          userEmail: this.appComponent.getUserEmail(),
        },
      });
    }
  }

  //Go back to the list page
  goBack() {
    this.router.navigate(['../contractors']);
  }

  editContractor() {
    this.router.navigate(['../add-edit-contractor/' + this.contractorID]);
  }

  getStateColor(color: string) {
    switch (color) {
      case 'Active':
        return 'green';
      case 'Pending Approval':
        return 'orange';
      case 'Blacklisted':
      case 'Standby':
      case 'Not Operating':
        return 'var(--mk3red)';
      default:
        return 'black';
    }
  }

  jobDetails(jobId: number) {
    this.router.navigate(['../job-details/' + jobId], {
      queryParams: { tabId: 4 },
    });
  }

  async retract(emailRecordId: number) {
    this.isLoading = true;
    const selectedRecord = this.dataSourceEmailRecords.data.find(x=>x.id === emailRecordId);
    const instructionType = (selectedRecord.instructionTypeId == '2' || selectedRecord.instructionTypeId == '4')?"quote request":"instruction";
    await this.utils.retractEmailRecord(emailRecordId,this.contractor.tradingName,this.contractor.contractorId,'Contractor',instructionType);
    this.isLoading = false;
  }

  getJobStatus(statusId: number) {
    return this.jobStatusesArray.find((item) => item.id == statusId)
      ?.description;
  }

  getNoteType(id: number) {
    return this.noteTypesArray.find((item) => item.id == id)?.type;
  }

  //Search by keyword
  onSearchKeyUp(search: { value: any },tab :string) {
    try {
      if(tab=='open')
      this.searchValueInstructionOpen =search.value;
      else if(tab=='close')
      this.searchValueInstructionClose =search.value;
      else if(tab=='all')
        this.searchValueInstructionAll =search.value;

     var currentFilter = search.value;
 this.filterInstructions(currentFilter);
     
   } catch (error) {
     Swal.fire('Error in Search by keyword : ' + error, '', 'error');
   }
 }

 filterInstructions(currentFilter: string)
 {
  let result;
  if (currentFilter && currentFilter.length > 0) {
    this.isLoading = true;
    result = this.dataSourceForEmailRecords.filteredData.filter(item => (item.refNo != null && item.refNo.toString().includes(currentFilter)) || 
                                      (item.id != null && item.id.toString().includes(currentFilter)) || 
                                      (item.instructionType != null && item.instructionType.toLowerCase().includes(currentFilter.toLowerCase())) || 
                                      (item.jobStatus != null && item.jobStatus.toLowerCase().includes(currentFilter.toLowerCase())) || 
                                      (item.attachmentName != null && item.attachmentName.toLowerCase().includes(currentFilter.toLowerCase())) || 
                                      (item.sentBy != null && item.sentBy.toLowerCase().includes(currentFilter.toLowerCase()))
                                   )
    this.dataSourceEmailRecords = new MatTableDataSource(result);
    this.isLoading = false;
    
  } else if (currentFilter == null || currentFilter.length == 0) {
    result = this.dataSourceForEmailRecords.filteredData;
    this.dataSourceEmailRecords = new MatTableDataSource(result);
    this.isLoading = false;
  }
 }

  //Clear search by keyword
  onClearClicked(search: { value: string },tab :string) {
    this.dataSourceForEmailRecords.filter = '';
    search.value ='';
    if(tab=='open')
    this.searchValueInstructionOpen ='';
    else if(tab=='close')
    this.searchValueInstructionClose ='';
    else if(tab=='all')
      this.searchValueInstructionAll ='';
    this.searchValueInstructionOpen ='';
    this.dataSourceEmailRecords = new MatTableDataSource(this.dataSourceForEmailRecords.filteredData);
       this.isLoading = false;
  }
  
  uploadDocument(){
      this.documentUploadDialogRef = this.dialog.open(
        DocumentDetailsComponent,
        {
          disableClose: true,
          //closeOnNavigation: false,
          data: {
            contractor: this.contractor,
            userName: this.appComponent.getUserName(),
            userEmail: this.appComponent.getUserEmail()
          },
        }
      )
      this.documentUploadDialogRef.afterClosed().subscribe(result => {
        if(result){
          this.isLoading = true;
          if(this.tabGroup.selectedIndex==7)
          this.getDocumentDetailByContractorId();
        else
        this.tabGroup.selectedIndex = 7;
        }
      });
  }

  getDocumentDetailByContractorId() {
    this.isLoading = true;
    return this.restService
      .getDocumentDetailByContractorId(this.route.snapshot.params.contractorId)
      .subscribe({
        next: (documentsDetails) => {
          this.isLoading = false;
          this.dataSourceDocumentDetail = new MatTableDataSource(documentsDetails);
          this.matSortCommon.sort(({ id: "documentId", start: "desc", disableClear: true }) as MatSortable);
          this.dataSourceDocumentDetail.sort = this.matSortCommon;
        },
        error: (error) => {
          this.isLoading = false;
          this.alertService.error(error);
        },
      });
  }
  openDocument(documentId : number){
    this.restService.getDocumentDetailByDocumentId(documentId).subscribe((doc) => {
      if(doc.fileType == PdfType)
      {
      this.functionsService.openPdf(doc.documentData);
      }
     else{
      const newWindow = window.open();
      const dataUrl = `data:${doc.fileType};base64,${doc.documentData}`;
      newWindow!.document.write(`<img src="${dataUrl}" width: auto; height:auto;/>`);
     }
    });
  }

  getUserDetails(){
    return this.restService.getADUserByEmail(this.globalValues.userEmailId).subscribe((userDetails) => {
      this.userDetails =userDetails;
      this.setPermission();
    });
  }

  sendTnC(){
    Swal.fire({
      title: 'Are you sure you want to send T&C agreement to this Contractor?',
      icon: 'question',
      showDenyButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
      confirmButtonColor: '#007bff',
      denyButtonColor: '#dc3545',
      focusDeny: true,
      width: 450,
      padding: '1em',
      heightAuto: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.sendTnC1();
      } else if (result.isDenied) {
        this.isLoading = false;
        return;
      }
    });
  }

  sendTnC1(){
    let tnc = new TncAgreement();
    tnc.id = uuidv4();
    tnc.contractorId = this.contractorID;
    tnc.documentTitle = 'Mk3 Terms & Conditions Agreement form v1' + ' ' + (new Date()).getFullYear().toString();
    tnc.dateSent = new Date(moment.utc(moment.utc().format()).local().utcOffset(0, true).format());
    tnc.versionNo = 1;

    this.restService. getDocumentDetailByDocumentId(2888).subscribe({
      next: (data: DocumentDetail)=> {

      this.restService.addTncAgreement(tnc).subscribe((response:HttpResponse<any>) => {
        if (response.status == 201){
          var email: Email;
          let url = 'https://sign.mk3.com.au/#/contractor-agreement/' + response.body.id.toString();
          let body = '<p>Hello ' + this.contractor.tradingName + ' ,</p> <p>As part of improving relationships with our valued contractors and suppliers, we have been working on improving the way in which Mk3 Group communicates our expectations and requirements when you work with the Mk3 Group by creating a standard set of terms and conditions and a new work instruction sheet. The terms and conditions provide clear detail on how we will manage our commercial relationship with our contractors and suppliers. The new Work Instruction Sheet will provide greater detail in regard to the way you will work with us on each job. The Work Instruction Sheet will still cover off the same basic elements such as scope of work and client details, however it will have more detail in the areas of timing for the works and the way in which works will be invoiced to the Mk3 Group as outlined below.</p> <p>There are three categories when it comes to the invoicing of works:</p> <ul> <li><strong>Fixed Price or Lump Sum</strong> - This is when you have submitted a quotation for the works, it has been approved, and the Work Instruction Sheet will cover the scope and the relevant quoted price.</li> <li><strong>Schedule of Rates</strong> - This is when you have submitted a prescribed schedule of rates and you will be given an allowance to complete the supplied scope of works under the agreed/approved schedule of rates. In some instances, you may be given authority to complete works up to a specific value ($1500 ex GST) utilising the agreed rates. This does not mean the order or Work Instruction Sheet is for the value of $1500 ex GST, it means you have authority up to $1500 ex GST. If your works are expected to exceed the pre-authorised value, you are to contact the issuing assessor and notify them of the increase and seek approval from them in writing before proceeding. All payment claims will need to be evidenced with time and materials and photographs of your work.</li> <li><strong>Day Rate</strong> - Being the actual evidenced and reasonable cost of undertaking the works inclusive of margin. Again, in some instances, you may be given authority to complete works up to a specific value ($1500 ex GST) utilising the agreed rates. This does not mean the order or Work Instruction Sheet is for the value of $1500 ex GST, it means you have authority up to $1500 ex GST. If your works are expected to exceed the pre-authorised value, you are to contact the issuing assessor and notify them of the increase and seek approval from them in writing before proceeding. All payment claims will need to be evidenced with time and materials and photographs of your work.</li> </ul> <p>Works values over $50,000 will require contract works insurance.</p> <p>Works values over $100,000 will require Personal Guarantee and Contract works Insurance.</p> <p>Attached is a sample of a Work Instruction Sheet and here is the link to the <a href="' + url + '">Mk3 Group Contractor Terms and Conditions</a>.</p> <p>If you could take the time to review both documents and sign the Contractor Terms and Conditions and please feel free to contact the compliance team should you have any further questions.</p> <p>Thank You,</p> <p>Regards,</p> <p>Mk3 Group Pty Ltd</p>';
          email = {
            from: 'trades@mk3.com.au',
            to: this.contractor.mainContactEmail,
            cc: 'michael.doran@nibaustralia.com.au',
            bcc: 'test@mk3.com.au;troy.mcfadden@mk3.com.au;',
            subject: 'Mk3 Group Terms and Conditions (Required Signing)',
            body: body,
            attachmentName: 'MK3 Work Instruction Sheet -Sample.pdf',
            attachmentContent: data.documentData,
            extraAttachmentName: null,
            extraAttachmentContent: null,
          };
          this.restService.sendEmail(email).subscribe(
            (response: any) => {
              if (response.status == 200) {
                Swal.fire(
                  'Contractor Send T&C Agreement successfully!\r\nEmail has been sent to the Contractor',
                  '',
                  'success'
                ).then(() => {
                  window.location.reload();
                });
              }
              else {
                Swal.fire(
                  'Contractor Send T&C Agreement failed!\r\nEmail has not sent to the Contractor, please contact the IT Department with details',
                  '',
                  'error'
                ).then(() => {
                  window.location.reload();
                });
              }
            },
            (err: any) => {
              Swal.fire(
                'Error occured when sending Contractor Send T&C Agreement Email: ' + err + 'Please contact the IT Department with details',
                '',
                'error'
              ).then(() => {
                window.location.reload();
              });
            },
          ); 
        }
        else{
          Swal.fire(
            'Add T&C Agreement record failed!\r\nPlease contact the IT Department with details',
            '',
            'error'
          ).then(() => {
            window.location.reload();
          });
        }
        },
        (err: any) => {
          Swal.fire(
            'Error occured when adding Contractor T&C Agreement record: ' + err + 'Please contact the IT Department with details',
            '',
            'error'
          ).then(() => {
            window.location.reload();
          });
        },
      );
    }}); 
    //},
    // (err: any) => {
    //   Swal.fire(
    //     'Error occured when getting file MK3 Work Instruction Sheet -Sample.pdf: ' + err + 'Please contact the IT Department with details',
    //     '',
    //     'error'
    //   ).then(() => {
    //     window.location.reload();
    //   });
    // },
    // }});  
  }

  setPermission(){
    if(this.userDetails && (DocumentUploadPermission.includes(Number(this.userDetails.employeeId!)) ||
                             this.appComponent.userGroupsArray.includes(groups.groupIT) || 
                             this.appComponent.userGroupsArray.includes(groups.groupManagement) || 
                             this.appComponent.userGroupsArray.includes(groups.groupManagementCloud)))
    this.hasPermissionToUploadDocument = true;
  }
}

